import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { SSMRequestModel } from '../business-entities/SSMRequest-model';
@Injectable({
    providedIn: 'root'
})
export class SSMDataService {
    constructor(private dataProvider: DataService) {
    }
    async ExportSSM(WoNo:string,dealerId:string,brand:string):Promise<any>{
            return this.dataProvider.Get<any>(Urls.ExportSSM,WoNo,dealerId,brand).toPromise();
        }
    async ImportSSM(model:SSMRequestModel):Promise<any>{
                return this.dataProvider.Post<any>(Urls.ImportSSM,model).toPromise();
            }
    async DeleteSSM(WoNo:string,dealerId:string):Promise<any>{
        return this.dataProvider.Get<any>(Urls.DeleteSSM,WoNo,dealerId).toPromise();
    }  
    }